// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminEventConsumersResponse

export type AdminEventConsumersApiResponse = {
	items: Array<string>;
};

export type AdminEventConsumers = {
	items: Array<string>;
};

export function hydrateAdminEventConsumers(data: AdminEventConsumersApiResponse): AdminEventConsumers {
	return { ...data };
}